"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const Loader_1 = require("../Loader");
const LoaderContainer = styled_1.default.div `
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: ${constants_1.theme.zIndex.backdrop};
`;
const Loading = () => {
    return ((0, jsx_runtime_1.jsx)(LoaderContainer, { children: (0, jsx_runtime_1.jsx)(Loader_1.Loader, { delayed: true, design: "fade" }) }));
};
exports.Loading = Loading;
